'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useMemo } from 'react';
import type { Icon } from '@personly/libs-types';
import { Record } from '@personly/libs-widgets';
import { useMediaQuery } from '@personly/libs-hooks';
import TableHeader from '@/components/table-header';
type Data = {
  axis: string;
  width?: number;
  icon?: Icon;
  header?: string;
  value?: string | ReactNode;
};
type DimensionData = {
  data: Data[];
};
type Dimension = {
  header: string;
  axis: string;
  width?: number;
  value?: string | ReactNode;
};
interface Props {
  data: DimensionData[];
  dimensions: Dimension[];
  orientation?: 'row' | 'column';
}
const key = (data: Data[], i: number) => data.reduce<string[]>((acc, cur) => [...acc, cur.axis], [i.toString()]).join(':');
const Table = t0 => {
  const $ = _c(13);
  const {
    data,
    dimensions,
    orientation: orient
  } = t0;
  const isLg = useMediaQuery("(min-width: 992px)");
  let t1;
  bb0: {
    if (orient) {
      t1 = orient;
      break bb0;
    }
    if (isLg) {
      t1 = "row";
      break bb0;
    }
    t1 = "column";
  }
  const orientation = t1;
  let t2;
  if ($[0] !== data.length || $[1] !== dimensions || $[2] !== orientation) {
    t2 = orientation === "row" && dimensions.length > 0 && data.length > 0 && <Record data={dimensions} first={true} last={true} legend={true} orientation={orientation}>{(displayHeader, displayValue, datum, legend) => <>{displayHeader && <TableHeader orientation={orientation} icon={datum.icon} legend={legend}>{datum.header}</TableHeader>}{displayValue && <div>{datum.value}</div>}</>}</Record>;
    $[0] = data.length;
    $[1] = dimensions;
    $[2] = orientation;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data || $[5] !== orientation) {
    let t4;
    if ($[7] !== data.length || $[8] !== orientation) {
      t4 = (dimensionData, i) => <Record key={key(dimensionData.data, i)} data={dimensionData.data} first={i === 0} last={i === data.length - 1} legend={false} orientation={orientation}>{(displayHeader_0, displayValue_0, datum_0, legend_0) => <>{displayHeader_0 && <TableHeader orientation={orientation} icon={datum_0.icon} legend={legend_0}>{datum_0.header}</TableHeader>}{displayValue_0 && <div>{datum_0.value}</div>}</>}</Record>;
      $[7] = data.length;
      $[8] = orientation;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = data.map(t4);
    $[4] = data;
    $[5] = orientation;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="text-xs">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default Table;